const config = {
  localhost: {
    legacyApiUrl: "http://localhost:2287",
  },
  "qa.cavs.app": {
    legacyApiUrl: "https://qa-legacy.cavs.app",
  },
  "cavs.app": {
    legacyApiUrl: "https://legacy.cavs.app",
  },
};

export default config[window.location.hostname];
